import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=6dbc2acf&scoped=true"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"
import style0 from "./Sorting.vue?vue&type=style&index=0&id=6dbc2acf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc2acf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbc2acf')) {
      api.createRecord('6dbc2acf', component.options)
    } else {
      api.reload('6dbc2acf', component.options)
    }
    module.hot.accept("./Sorting.vue?vue&type=template&id=6dbc2acf&scoped=true", function () {
      api.rerender('6dbc2acf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/section/Sorting.vue"
export default component.exports